'use client';

import Image from 'next/image';
import { Github, Twitter, Linkedin, Mail, Loader2, CheckCircle, ArrowRight } from 'lucide-react';
import { useState } from 'react';
interface AuthorSidebarProps {
  className?: string;
}
export function AuthorSidebar({
  className = ''
}: AuthorSidebarProps) {
  // Updated to match About page details
  const authorName = "Lalit Choudhary";
  const authorRole = "Full Stack Innovator & Tech Writer";
  const authorBio = "Bridging the gap between human creativity and machine intelligence. Building systems that scale and writing words that inspire.";
  const authorImage = "/images/profile.jpg";
  const [isExpanded, setIsExpanded] = useState(false);
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');
  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('loading');
    try {
      const res = await fetch('/api/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email
        })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Something went wrong');
      setStatus('success');
      setMessage('Subscribed!');
      setEmail('');
      setTimeout(() => {
        setIsExpanded(false);
        setStatus('idle');
        setMessage('');
      }, 3000);
    } catch (error) {
      console.error('Subscription error:', error);
      setStatus('error');
      setMessage('Failed to subscribe');
    }
  };
  return <div className={`bg-card rounded-2xl p-6 border border-border shadow-sm mb-8 ${className}`}>
            <div className="flex flex-col items-center text-center">
                <div className="relative w-24 h-24 mb-4">
                    <Image src={authorImage} alt={authorName} fill className="object-cover rounded-full border-4 border-background shadow-md" priority />
                    <div className="absolute bottom-0 right-0 w-6 h-6 bg-green-500 border-4 border-background rounded-full" title="Online" />
                </div>

                <h3 className="text-xl font-bold text-foreground mb-1">{authorName}</h3>
                <p className="text-sm font-medium text-primary mb-3">{authorRole}</p>

                <p className="text-sm text-muted-foreground mb-6 leading-relaxed">
                    {authorBio}
                </p>

                <div className="flex items-center gap-4 text-muted-foreground">
                    <a href="#" className="hover:text-primary transition-colors" aria-label="Twitter">
                        <Twitter className="w-5 h-5" />
                    </a>
                    <a href="#" className="hover:text-primary transition-colors" aria-label="GitHub">
                        <Github className="w-5 h-5" />
                    </a>
                    <a href="#" className="hover:text-primary transition-colors" aria-label="LinkedIn">
                        <Linkedin className="w-5 h-5" />
                    </a>
                    <a href="mailto:contact@techknowlogia.live" className="hover:text-primary transition-colors" aria-label="Email">
                        <Mail className="w-5 h-5" />
                    </a>
                </div>

                {!isExpanded ? <button onClick={() => setIsExpanded(true)} className="w-full mt-6 py-2 px-4 bg-primary/10 hover:bg-primary/20 text-primary rounded-lg text-sm font-medium transition-colors flex items-center justify-center gap-2 group">
                        Subscribe to Newsletter
                        <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                    </button> : <form onSubmit={handleSubscribe} className="w-full mt-6 space-y-2 animate-in fade-in slide-in-from-top-2 duration-200">
                        <input type="email" placeholder="Email address" className="w-full h-9 rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring" value={email} onChange={e_0 => setEmail(e_0.target.value)} required autoFocus />
                        <button type="submit" disabled={status === 'loading' || status === 'success'} className="w-full py-2 px-4 bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg text-sm font-medium transition-colors flex items-center justify-center gap-2">
                            {status === 'loading' ? <Loader2 className="w-4 h-4 animate-spin" /> : status === 'success' ? <>
                                    <CheckCircle className="w-4 h-4" />
                                    Subscribed
                                </> : 'Join Now'}
                        </button>
                        {status === 'error' && <p className="text-xs text-red-500 font-medium">{message}</p>}
                    </form>}
            </div>
        </div>;
}